import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "itemTypeInput", "searchItemType"]

  /**
   * フォームを自動送信します。
   * ラジオボタンの変更時に呼び出られます。
   */
  submitForm() {
    this.element.requestSubmit()
  }

  /**
   * タブを切り替えてフォームを送信します。
   */
  switchTab(event) {
    const value = event.currentTarget.dataset.value

    // 隠しフィールドに値を設定
    // まずページ上の他のフォームにある q[...] パラメータをコピーして
    // タブフォームに挿入する（既存の検索条件を保持するため）。
    // this.element（タブフォーム）内の q[...] は上書きされる。
    const allQElems = Array.from(document.querySelectorAll('[name^="q["]'))
    allQElems.forEach(el => {
      // this.element 内の要素はスキップ（既にフォーム内にあるもの）
      if (this.element.contains(el)) return
      // 検索フォームのタイプ要素もスキップ（後で個別に処理）
      if (el.name === 'q[item_type_eq]') return

      const name = el.name

      // checkbox / radio の場合、チェックされているものだけコピーする
      if (el.type === 'checkbox' || el.type === 'radio') {
        if (!el.checked) return
      }

      // select[multiple] の場合は選択された各値を hidden input として追加
      if (el.tagName.toLowerCase() === 'select' && el.multiple) {
        Array.from(el.selectedOptions).forEach(opt => {
          const hidden = document.createElement('input')
          hidden.type = 'hidden'
          hidden.name = name
          hidden.value = opt.value
          this.element.appendChild(hidden)
        })
        return
      }

      // 通常の input / textarea / select（単一選択）の場合は 1 つの hidden を作る（上書き）
      let hidden = this.element.querySelector(`input[name="${name}"]`)
      if (!hidden) {
        hidden = document.createElement('input')
        hidden.type = 'hidden'
        hidden.name = name
        this.element.appendChild(hidden)
      }
      hidden.value = el.value
    })

    // item_type_eq は必ず現在のタブ値で上書きする
    let input = this.element.querySelector('input[name="q[item_type_eq]"]')
    if (!input) {
      input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'q[item_type_eq]'
      this.element.appendChild(input)
    }
    input.value = value

    // 検索フォーム側の item_type_eq も同期する
    if (this.hasSearchItemTypeTarget) {
      this.searchItemTypeTarget.value = value
    }

    // タブのアクティブ状態を更新
    this.tabTargets.forEach(tab => {
      if (tab.dataset.value === value) {
        tab.classList.add('tab-active')
      } else {
        tab.classList.remove('tab-active')
      }
    })

    // フォーム送信
    this.element.requestSubmit()
  }
}
